import { BinderFailuresByWarrantyType } from "@dune/types";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@dune/ui";
import { getWarrantyTypeDisplayName } from "@dune/utils";
import { paramKeyToDescription } from "@dune/vars";
import { XIcon } from "lucide-react";

const FormattedMessage = ({ message }: { message: string }) => {
	const parts = message.split(/(\*\*[^*]+\*\*)/g);

	return (
		<span>
			{parts.map((part, partIndex) => {
				if (part.startsWith("**") && part.endsWith("**")) {
					const text = part.slice(2, -2);
					return (
						<strong key={`bold-${text.substring(0, 20)}-${partIndex}`}>
							{text}
						</strong>
					);
				}
				return (
					<span key={`text-${part.substring(0, 20)}-${partIndex}`}>{part}</span>
				);
			})}
		</span>
	);
};

const ConstructionSiteBindersErrors = ({
	failures,
}: { failures: BinderFailuresByWarrantyType }) => {
	const warrantyTypes = Object.keys(failures);
	if (warrantyTypes.length === 0) return null;
	return (
		<div className="flex items-center justify-center p-6 w-full">
			<div className="flex flex-col items-center justify-center p-4 gap-4 w-full">
				<div className="flex flex-col gap-4 w-full h-full border-solid border-1 border-gray-200 rounded-lg p-6">
					<p className="font-medium">
						<b>
							DUNE n'est pas en mesure de vous proposer les offres d'assurance
							suivantes :
						</b>
					</p>

					<Tabs defaultValue={warrantyTypes[0]} className="w-full">
						<TabsList className="">
							{warrantyTypes.map((warrantyType) => (
								<TabsTrigger key={warrantyType} value={warrantyType}>
									{getWarrantyTypeDisplayName(warrantyType)}
								</TabsTrigger>
							))}
						</TabsList>

						{warrantyTypes.map((warrantyType) => {
							const warrantyFailures =
								failures[warrantyType as keyof BinderFailuresByWarrantyType];
							if (!warrantyFailures) return null;

							return (
								<TabsContent
									key={warrantyType}
									value={warrantyType}
									className="mt-4"
								>
									<div className="flex flex-col gap-4">
										{Object.entries(warrantyFailures).map(
											([paramKey, messages]) => (
												<div
													key={`${paramKey}`}
													className="flex flex-row gap-4 w-full border-solid border-1 border-gray-200 rounded-lg p-4 bg-gray-100"
												>
													<XIcon
														className="text-red-500 flex-shrink-0 mt-1"
														size={20}
													/>
													<div className="flex flex-col gap-4">
														<p className="font-semibold text-gray-800 text-lg">
															{
																paramKeyToDescription[
																	paramKey as keyof typeof paramKeyToDescription
																]
															}
														</p>
														{messages.map((message, index) => (
															<div
																key={`${paramKey}-${message.substring(0, 50)}-${index}`}
																className="flex flex-row gap-4 w-full rounded-lg bg-gray-100"
															>
																{/* Marker-based formatting with **bold** syntax */}
																<p className="text-gray-800">
																	<FormattedMessage message={message} />
																</p>
															</div>
														))}
													</div>
												</div>
											),
										)}
									</div>
								</TabsContent>
							);
						})}
					</Tabs>
				</div>
			</div>
		</div>
	);
};

export default ConstructionSiteBindersErrors;
